import React from "react";
import { MarkDownPage } from "@shared/layout/MarkDownPage";

const PrivacyPolicyText = `
# Редакция от: 10.05.2026

Настоящая Политика определяет порядок обработки и защиты персональных данных пользователей приложения ТИСИТ.

Оператор персональных данных: Общество с ограниченной ответственностью «ТИСИТ», ОГРН 1242300059451, ИНН 2370015904, адрес: 353564, Краснодарский край, м. р-н Славянский, г. п. Славянское, г. Славянск-на-Кубани, ул. Школьная, д. 179.

Email для обращений по вопросам персональных данных: help@tisit.club.

## **1. Общие положения**

1.1. Настоящая Политика разработана в соответствии с Федеральным законом № 152-ФЗ «О персональных данных» и иными применимыми нормативными актами Российской Федерации.

1.2. Политика применяется к мобильному приложению ТИСИТ, аккаунту Пользователя, сайту, коммуникациям, сервисам и иным функциям, связанным с Приложением.

1.3. Используя Приложение, Пользователь подтверждает, что ознакомился с настоящей Политикой.

1.4. В случаях, предусмотренных законодательством, Оператор запрашивает отдельное согласие Пользователя на обработку персональных данных.

1.5. Если Пользователь не согласен с настоящей Политикой, он обязан прекратить использование Приложения.

1.6. Оператор обеспечивает неограниченный доступ к настоящей Политике путём размещения её в Приложении и/или на сайте Компании.

## **2. Принципы обработки персональных данных**

2.1. Оператор обрабатывает персональные данные законно и справедливо.

2.2. Обработка ограничивается достижением конкретных, заранее определённых и законных целей.

2.3. Оператор не обрабатывает персональные данные, несовместимые с целями их сбора.

2.4. Объём и содержание обрабатываемых данных соответствуют заявленным целям обработки.

2.5. Оператор принимает меры по обеспечению точности, достаточности и актуальности персональных данных.

2.6. Персональные данные хранятся не дольше, чем этого требуют цели обработки, договор с Пользователем или законодательство Российской Федерации.

## **3. Категории обрабатываемых данных**

3.1. Оператор может обрабатывать следующие категории персональных данных:

а) данные аккаунта: имя, фамилия, никнейм, дата рождения, возраст, пол, email, номер телефона при наличии, идентификатор пользователя, пароль в защищённом виде;

б) данные профиля: фото профиля, аватар, настройки профиля, язык, часовой пояс, иные сведения, указанные Пользователем;

в) данные о физической активности: выбранные программы, тренировки, упражнения, подходы, повторы, время выполнения, история тренировок, прогресс, цели, уровень подготовки;

г) антропометрические и фитнес-данные: рост, вес, телосложение, измерения тела, динамика показателей, пользовательские цели;

д) сведения о самочувствии, ограничениях, травмах, противопоказаниях или заболеваниях, если Пользователь добровольно указывает такие сведения в Приложении;

е) технические данные: IP-адрес, тип устройства, модель устройства, операционная система, версия приложения, язык устройства, идентификаторы устройства, push-токен, данные о сбоях, логах, диагностике и производительности;

ж) данные использования: действия в Приложении, посещённые экраны, клики, события, настройки, выбранные функции, дата и время действий;

з) данные обращений: сообщения в поддержку, отзывы, комментарии, жалобы, ответы на опросы, переписка с Компанией;

и) данные платежей в будущем: сведения о факте оплаты, тарифе, подписке, статусе платежа, идентификаторе транзакции, платёжном провайдере или магазине приложений. Полные данные банковской карты Оператор не хранит, если платёж проводится через внешний платёжный сервис;

к) данные, полученные через внешние сервисы или интеграции, если Пользователь самостоятельно подключает такие функции и предоставляет разрешения.

3.2. Оператор не требует от Пользователя предоставления медицинских документов, диагнозов, результатов медицинских обследований или иных медицинских сведений.

3.3. Если Пользователь добровольно указывает сведения о состоянии здоровья, травмах, заболеваниях, противопоказаниях, ограничениях по нагрузке или самочувствии, такие сведения могут относиться к специальным категориям персональных данных. Обработка специальных категорий персональных данных о состоянии здоровья по общему правилу ограничена и допускается только при наличии оснований, предусмотренных законом.

## **4. Данные несовершеннолетних пользователей**

4.1. Приложение доступно Пользователям с 14 лет.

4.2. Пользователь в возрасте от 14 до 18 лет использует Приложение при наличии согласия законного представителя.

4.3. Начиная использовать Приложение, несовершеннолетний Пользователь подтверждает, что получил согласие законного представителя на использование Приложения и обработку персональных данных в объёме, необходимом для работы Приложения.

4.4. Оператор не проводит обязательную предварительную верификацию согласия законного представителя, однако вправе запросить такое подтверждение при необходимости.

4.5. Законный представитель несовершеннолетнего Пользователя может направить запрос, связанный с обработкой персональных данных несовершеннолетнего, по адресу help@tisit.club.

## **5. Цели обработки персональных данных**

5.1. Оператор обрабатывает персональные данные в следующих целях:

а) регистрация, идентификация и авторизация Пользователя;

б) создание и ведение аккаунта;

в) предоставление доступа к Приложению и его функциям;

г) отображение профиля, фото профиля, настроек и пользовательских данных;

д) формирование тренировочного опыта, отображение упражнений, тренировок, программ, прогресса и статистики;

е) персонализация интерфейса и функций Приложения;

ж) обработка обращений, отзывов, комментариев, жалоб и запросов;

з) обеспечение безопасности Приложения, предотвращение мошенничества, злоупотреблений и несанкционированного доступа;

и) диагностика ошибок, анализ сбоев и повышение стабильности Приложения;

к) улучшение качества Приложения, разработка новых функций и проведение продуктовой аналитики;

л) направление сервисных уведомлений;

м) направление маркетинговых сообщений при наличии отдельного согласия, если такое согласие требуется законом;

н) подготовка к внедрению платных функций, обработка оплат и подписок в будущем;

о) исполнение требований законодательства Российской Федерации, судебных актов и законных запросов государственных органов;

п) защита прав и законных интересов Оператора, Пользователей и третьих лиц.

## **6. Правовые основания обработки**

6.1. Оператор обрабатывает персональные данные на следующих основаниях:

а) согласие Пользователя;

б) заключение и исполнение Пользовательского соглашения;

в) исполнение требований законодательства Российской Федерации;

г) осуществление прав и законных интересов Оператора, если при этом не нарушаются права и свободы Пользователя;

д) иные основания, предусмотренные законодательством Российской Федерации.

6.2. Для обработки специальных категорий персональных данных, маркетинговых коммуникаций, трансграничной передачи в случаях, требующих отдельного согласия, и иных случаев, предусмотренных законом, Оператор запрашивает отдельное согласие.

6.3. Согласие на обработку персональных данных должно быть конкретным, предметным, информированным, сознательным и однозначным. Для отдельных видов обработки закон предусматривает специальные требования к форме и содержанию согласия.

## **7. Действия с персональными данными**

7.1. Оператор может совершать с персональными данными следующие действия: сбор, запись, систематизацию, накопление, хранение, уточнение, обновление, изменение, извлечение, использование, передачу, предоставление, доступ, обезличивание, блокирование, удаление, уничтожение.

7.2. Обработка может осуществляться с использованием средств автоматизации и без использования таких средств.

7.3. Оператор может использовать алгоритмы персонализации для отображения тренировок, рекомендаций, прогресса и релевантного контента. Такие алгоритмы не являются медицинской диагностикой и не заменяют консультацию специалиста.

## **8. Специальные категории персональных данных**

8.1. Приложение не является медицинским сервисом и не требует предоставления медицинских данных.

8.2. Если Пользователь добровольно указывает сведения о состоянии здоровья, травмах, заболеваниях, противопоказаниях, ограничениях по нагрузке или самочувствии, такие сведения могут относиться к специальным категориям персональных данных.

8.3. Оператор обрабатывает такие сведения только при наличии отдельного согласия Пользователя или иного законного основания.

8.4. Цель обработки таких сведений — учёт добровольно указанных ограничений, персонализация фитнес-функций, отображение прогресса и повышение безопасности пользовательского опыта.

8.5. Пользователь не обязан предоставлять такие сведения. Отказ от предоставления или отзыв согласия может привести к недоступности отдельных персонализированных функций.

8.6. Оператор не использует такие сведения для постановки диагноза, лечения, профилактики заболеваний или принятия медицинских решений.

## **9. Фото профиля, отзывы и комментарии**

9.1. Пользователь может загрузить фото профиля, если такая функция доступна.

9.2. Пользователь самостоятельно отвечает за законность загружаемого фото и подтверждает, что обладает правами на его использование.

9.3. Пользователь не должен загружать фото третьих лиц без их согласия.

9.4. Если в Приложении доступны отзывы и комментарии, Пользователь самостоятельно отвечает за их содержание.

9.5. Оператор вправе модерировать, скрывать или удалять отзывы, комментарии и фото профиля, если они нарушают закон, права третьих лиц, Пользовательское соглашение или правила Приложения.

9.6. Если фото профиля, отзывы или комментарии становятся видимыми другим пользователям, партнёрам или неопределённому кругу лиц, для такой публикации может потребоваться отдельное согласие на обработку персональных данных, разрешённых субъектом для распространения. Такое согласие должно оформляться отдельно от иных согласий.

## **10. Передача данных третьим лицам**

10.1. Оператор не продаёт персональные данные Пользователей.

10.2. Оператор может передавать персональные данные третьим лицам в следующих случаях:

а) Пользователь дал согласие;

б) передача необходима для работы Приложения и исполнения Пользовательского соглашения;

в) передача необходима для диагностики ошибок, технической поддержки, аналитики, безопасности и улучшения Приложения;

г) передача необходима платёжным провайдерам, банкам, магазинам приложений и иным участникам оплаты после внедрения платных функций;

д) передача требуется по закону, судебному акту или законному запросу государственного органа;

е) передача необходима для защиты прав, безопасности и законных интересов Оператора, Пользователей или третьих лиц;

ж) передача происходит в рамках реорганизации, продажи бизнеса, передачи прав на Приложение или иной законной сделки при условии соблюдения требований закона.

10.3. При поручении обработки персональных данных третьим лицам Оператор заключает договор или иное поручение, предусматривающее цели обработки, перечень действий с данными, обязанности по конфиденциальности, безопасности и соблюдению требований законодательства.

## **11. Используемые внешние сервисы**

11.1. Оператор может использовать следующие внешние сервисы:

а) Sentry — для диагностики ошибок, crash-reporting, анализа технических сбоев и повышения стабильности Приложения;

б) Gemini — для работы с отдельными AI-функциями, обработки запросов, генерации или улучшения текстов, анализа пользовательских обращений или внутренних процессов Компании;

в) OpenAI — для работы с отдельными AI-функциями, обработки запросов, генерации или улучшения текстов, анализа пользовательских обращений или внутренних процессов Компании.

11.2. Оператор принимает меры для минимизации состава данных, передаваемых внешним сервисам.

11.3. По возможности Оператор не передаёт во внешние AI-сервисы специальные категории персональных данных, платёжные данные, пароли, документы, данные несовершеннолетних и иные сведения, не необходимые для конкретной цели обработки.

11.4. Если Пользователь самостоятельно вводит в поле запроса или обращения персональные данные, такие данные могут быть обработаны в рамках соответствующей функции.

11.5. Оператор вправе использовать обезличивание, псевдонимизацию, маскирование, ограничение доступа и иные меры защиты для снижения рисков обработки.

## **12. Трансграничная передача и хранение данных в России**

12.1. Основные базы данных Пользователей Российской Федерации размещаются на серверах, расположенных на территории Российской Федерации.

12.2. При сборе персональных данных граждан Российской Федерации Оператор обеспечивает запись, систематизацию, накопление, хранение, уточнение и извлечение таких данных с использованием баз данных, находящихся на территории Российской Федерации, если это требуется законодательством Российской Федерации.

12.3. Отдельные технические, аналитические или AI-сервисы могут предоставляться иностранными поставщиками. В таких случаях возможна трансграничная передача персональных данных.

12.4. Трансграничная передача персональных данных осуществляется только при наличии правового основания и соблюдении требований законодательства Российской Федерации.

12.5. Пользователь вправе запросить информацию о трансграничной передаче его персональных данных, направив обращение на help@tisit.club.

## **13. Хранение персональных данных**

13.1. Персональные данные хранятся не дольше, чем требуется для целей обработки, исполнения Пользовательского соглашения, соблюдения законодательства Российской Федерации, рассмотрения обращений, защиты прав и разрешения споров.

13.2. Данные аккаунта хранятся в течение срока использования Приложения и после удаления аккаунта в пределах сроков, необходимых для исполнения закона и защиты прав Оператора.

13.3. Данные о тренировках, физической активности и прогрессе хранятся до удаления аккаунта Пользователем или до истечения срока, необходимого для целей обработки.

13.4. Фото профиля, отзывы и комментарии хранятся до удаления Пользователем, удаления аккаунта, удаления Оператором по основаниям, предусмотренным документами Приложения, или до достижения целей обработки.

13.5. Платёжные и бухгалтерские сведения после внедрения платных функций хранятся в сроки, предусмотренные законодательством Российской Федерации.

13.6. Технические логи, данные безопасности и сведения о сбоях хранятся в течение срока, необходимого для обеспечения безопасности, расследования инцидентов, исправления ошибок и защиты прав Оператора.

13.7. По достижении целей обработки или при утрате правового основания персональные данные удаляются, уничтожаются или обезличиваются, если иное не требуется законодательством Российской Федерации.

## **14. Защита персональных данных**

14.1. Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, предоставления, распространения и иных неправомерных действий.

14.2. Такие меры могут включать:

а) назначение лиц, ответственных за организацию обработки персональных данных;

б) принятие локальных актов по вопросам обработки и защиты персональных данных;

в) ограничение доступа сотрудников и подрядчиков к персональным данным;

г) разграничение прав доступа;

д) использование средств аутентификации;

е) шифрование, хеширование или иные способы защиты данных, где применимо;

ж) резервное копирование;

з) журналирование действий и мониторинг безопасности;

и) проверку подрядчиков и оформление поручений на обработку;

к) реагирование на инциденты информационной безопасности.

14.3. Требования к защите персональных данных в информационных системах определяются с учётом уровня защищённости, характера угроз, категорий данных и требований законодательства Российской Федерации.

14.4. Пользователь обязан самостоятельно обеспечивать безопасность своего устройства, пароля и доступа к аккаунту.

## **15. Права Пользователя**

15.1. Пользователь имеет право:

а) получать информацию об обработке своих персональных данных;

б) требовать уточнения персональных данных;

в) требовать блокирования или уничтожения персональных данных, если они являются неполными, устаревшими, неточными, незаконно полученными или не нужны для заявленной цели обработки;

г) отзывать согласие на обработку персональных данных;

д) требовать прекращения обработки персональных данных в случаях, предусмотренных законом;

е) обжаловать действия или бездействие Оператора в Роскомнадзор или суд;

ж) реализовывать иные права, предусмотренные законодательством Российской Федерации.

15.2. Для реализации прав Пользователь направляет запрос на help@tisit.club.

15.3. Запрос должен позволять идентифицировать Пользователя и его аккаунт.

15.4. Оператор вправе запросить дополнительные сведения, если это необходимо для подтверждения личности Пользователя или полномочий заявителя.

15.5. Оператор отвечает на запросы Пользователей в сроки, предусмотренные законодательством Российской Федерации.

## **16. Отзыв согласия**

16.1. Пользователь вправе отозвать согласие на обработку персональных данных, направив запрос на help@tisit.club.

16.2. После получения отзыва Оператор прекращает обработку персональных данных, если отсутствуют иные законные основания для продолжения обработки.

16.3. Отзыв согласия на обработку данных, необходимых для работы Приложения, может привести к невозможности использования аккаунта или отдельных функций.

16.4. Отзыв согласия на маркетинговые сообщения не влияет на направление сервисных уведомлений, связанных с аккаунтом, безопасностью, изменением документов, техническими вопросами и исполнением Пользовательского соглашения.

## **17. Удаление аккаунта и данных**

17.1. Пользователь может удалить аккаунт через функциональность Приложения, если она доступна, либо направить запрос на help@tisit.club.

17.2. После удаления аккаунта Оператор удаляет или обезличивает персональные данные, за исключением данных, которые должны храниться в силу закона, договора, бухгалтерских требований, необходимости рассмотрения споров, предотвращения мошенничества или защиты прав.

17.3. Удаление Приложения с устройства само по себе не означает удаление аккаунта и данных на серверах Оператора.

## **18. Cookies, SDK и аналогичные технологии**

18.1. В Приложении и связанных веб-страницах могут использоваться cookies, SDK, пиксели, аналитические идентификаторы, push-токены, crash-reporting-инструменты и иные аналогичные технологии.

18.2. Эти технологии используются для:

а) авторизации и сохранения сессии;

б) обеспечения безопасности;

в) запоминания настроек;

г) аналитики использования Приложения;

д) диагностики ошибок;

е) улучшения интерфейса и функций;

ж) направления push-уведомлений;

з) маркетинга и оценки эффективности коммуникаций при наличии необходимых согласий.

18.3. Пользователь может ограничить использование отдельных технологий через настройки устройства, операционной системы, браузера или Приложения. Ограничение может повлиять на доступность отдельных функций.

## **19. Маркетинговые коммуникации**

19.1. Оператор может направлять Пользователю новости, предложения, акции, рекомендации и иные маркетинговые сообщения при наличии согласия Пользователя, если такое согласие требуется законодательством.

19.2. Пользователь вправе отказаться от маркетинговых сообщений через настройки Приложения, ссылку отписки в сообщении или обращение на help@tisit.club.

19.3. Отказ от маркетинговых сообщений не препятствует направлению сервисных уведомлений.

## **20. Обезличенные данные и аналитика**

20.1. Оператор вправе обезличивать данные и использовать обезличенную статистику для аналитики, исследований, улучшения Приложения, развития продукта, оценки эффективности функций и подготовки внутренних отчётов.

20.2. Обезличенные данные не позволяют без использования дополнительной информации определить конкретного Пользователя.

20.3. Оператор может передавать обезличенные данные партнёрам, подрядчикам или исследовательским сервисам, если такая передача не нарушает права Пользователей и требования законодательства.

## **21. Инциденты безопасности**

21.1. При выявлении неправомерной или случайной передачи, предоставления, распространения или доступа к персональным данным Оператор принимает меры реагирования, оценки последствий, устранения причин и выполнения обязанностей, предусмотренных законодательством Российской Федерации.

21.2. В случаях, предусмотренных законом, Оператор уведомляет уполномоченный орган и/или Пользователей о соответствующем инциденте.

## **22. Изменение Политики**

22.1. Оператор вправе изменять настоящую Политику.

22.2. Новая редакция размещается в Приложении и/или на сайте Оператора.

22.3. Если изменения существенно влияют на права Пользователя или способы обработки данных, Оператор по возможности уведомляет Пользователя через Приложение, email, push-уведомление или иной доступный канал.

22.4. В случаях, когда требуется отдельное согласие, Оператор запрашивает его отдельно.

## **23. Реквизиты Оператора**

Общество с ограниченной ответственностью «ТИСИТ»

ОГРН: 1242300059451

ИНН: 2370015904

Адрес: 353564, Краснодарский край, м. р-н Славянский, г. п. Славянское, г. Славянск-на-Кубани, ул. Школьная, д. 179

Email: help@tisit.club

Я, Пользователь приложения TISIT, свободно, своей волей и в своём интересе даю Обществу с ограниченной ответственностью «ТИСИТ», ОГРН 1242300059451, ИНН 2370015904, адрес: 353564, Краснодарский край, м. р-н Славянский, г. п. Славянское, г. Славянск-на-Кубани, ул. Школьная, д. 179, согласие на обработку специальных категорий персональных данных, которые я добровольно указываю в Приложении.

К таким данным могут относиться сведения о состоянии здоровья, самочувствии, травмах, заболеваниях, противопоказаниях, ограничениях по физическим нагрузкам, а также иные сведения, которые могут относиться к состоянию здоровья.

Я понимаю, что Приложение не является медицинским сервисом, не оказывает медицинские услуги, не ставит диагнозы, не назначает лечение и не заменяет консультацию врача.

Цели обработки: учёт добровольно указанных ограничений, персонализация фитнес-функций, отображение прогресса, повышение безопасности пользовательского опыта, техническая поддержка и улучшение качества Приложения.

Разрешённые действия с данными: сбор, запись, систематизация, накопление, хранение, уточнение, обновление, изменение, извлечение, использование, обезличивание, блокирование, удаление, уничтожение, а также передача третьим лицам в случаях, указанных в Политике конфиденциальности и необходимых для работы Приложения.

Я понимаю, что не обязан(а) предоставлять такие данные. Отказ от предоставления или отзыв согласия может привести к недоступности отдельных персонализированных функций.

Согласие действует до его отзыва или до достижения целей обработки, если иной срок хранения не предусмотрен законодательством Российской Федерации.

Согласие может быть отозвано путём направления запроса на help@tisit.club.
`;

export const PrivacyPolicy = () => {
  return <MarkDownPage text={PrivacyPolicyText} />;
};
